export const themes = {
  default: {
    thItem: 'flex-none relative',
    thItemImage: 'overflow-hidden rounded-12',
    thItemLabel:
      'flex font-bold gap-5 items-baseline leading-normal mt-10 overflow-hidden text-14 text-black',
    thItemLabelIcon: 'mt-1 shrink-0 text-sienna',
    thItemLabelIconSize: '1em',
  },
};
